module.exports = __webpack_public_path__ + "img/banner_eolp.7f2671d.webp";